import { shallowEqual } from 'react-redux';

import { Box, Heading } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import { useSelector } from '../../selectors/useSelector';

import { useGetHelpArticles } from '../../hooks/queries/support';

import { StyledAnchor } from './styles';

import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';
import type { HelpArticle } from '../../model/HelpArticles';

const HelpArticlesContent = () => {
  const {
    submitRequest: { selectedHelpCategory, selectedHelpTopic },
  } = useSelector((state) => {
    return { submitRequest: state.submitRequest };
  }, shallowEqual);

  const { data: helpArticlesData, error: helpArticlesError } = useGetHelpArticles({
    category: selectedHelpCategory?.key || '',
    topic: selectedHelpTopic?.key || '',
  });

  //  if there is an error just don't show the articles section
  if (helpArticlesError || !helpArticlesData) return null;

  const renderHelpArticle = (helpArticle: HelpArticle) => {
    const { title, contents } = helpArticle;

    return (
      <>
        <Box css={{ marginBottom: '200' }}>
          <PartialMessage partialMessages={title} linkComponent={StyledAnchor} fontType="bodySmall" />
        </Box>
        {contents?.length > 0 && (
          <Box css={{ marginBottom: '600' }}>
            {contents?.map((c: Array<PartialMessageProps>, i) => {
              return (
                <PartialMessage
                  key={`help-article-contents-${i}`}
                  partialMessages={c}
                  linkComponent={StyledAnchor}
                  fontType="bodySmall"
                />
              );
            })}
          </Box>
        )}
      </>
    );
  };

  return (
    <Box data-testid="HelpArticles" css={{ marginLeft: { base: 0, xl: '1200' }, marginTop: { base: '800', xl: 0 } }}>
      {helpArticlesData?.heading && (
        <Heading level={6} css={{ marginBottom: '600' }}>
          {helpArticlesData?.heading}
        </Heading>
      )}
      {helpArticlesData?.helpArticles?.map((helpArticle: HelpArticle, i: number) => {
        return <div key={`help-article-${i}`}>{renderHelpArticle(helpArticle)}</div>;
      })}
    </Box>
  );
};

export default HelpArticlesContent;
